(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorela-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sorela-carousel]').forEach((carousel) => {
    if (carousel.dataset.initialized === 'true') return;
    carousel.dataset.initialized = 'true';
    const slides = [...carousel.querySelectorAll('.sorela-hero-carousel__slide')];
    const currentLabel = carousel.querySelector('[data-carousel-current]');
    let current = 0;
    let timer;
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.tabIndex = active ? 0 : -1;
      });
      if (currentLabel) currentLabel.textContent = String(current + 1);
    };
    const restart = () => {
      clearInterval(timer);
      timer = setInterval(() => show(current + 1), 4000);
    };
    carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => { show(current - 1); restart(); });
    carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => { show(current + 1); restart(); });
    carousel.addEventListener('mouseenter', () => clearInterval(timer));
    carousel.addEventListener('mouseleave', restart);
    show(0);
    restart();
  });

  } catch(e) { console.error(e); }
})();
})();
